module.exports = __webpack_public_path__ + "img/baitian.8afbc072.png";